define('OutSystems/ReactWidgets/Checkbox',["require", "exports", "tslib", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Settings_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Checkbox = void 0;
    var Checkbox = (function (_super) {
        tslib_1.__extends(Checkbox, _super);
        function Checkbox(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.state = { value: props.variable.value };
            return _this;
        }
        Checkbox.prototype.onChange = function (event) {
            var _this = this;
            var elem = event.target;
            this.props.variable.value = elem.checked;
            this.setState({ value: elem.checked }, function () {
                if (_this.props.onChange) {
                    _this.executeAfterPaint(function () {
                        _this.executeWithActiveClassOn(function () { return _this.props.onChange(); });
                    });
                }
            });
        };
        Object.defineProperty(Checkbox.prototype, "htmlElement", {
            get: function () {
                return this.getHTMLNode();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Checkbox.prototype, "inputedValue", {
            get: function () {
                return this.htmlElement.checked;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Checkbox.prototype, "inputedValueValidity", {
            get: function () {
                return this.htmlElement.validity;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Checkbox.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Checkbox.prototype.updateValue = function (value) {
            this.setState({ value: value });
        };
        Checkbox.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            if (this.props.variable.value !== nextProps.variable.value) {
                this.updateValue(nextProps.variable.value);
            }
        };
        Checkbox.prototype.render = function () {
            var _this = this;
            var checkboxAttributes = tslib_1.__assign({ "data-checkbox": "", className: this.props.style, disabled: !this.props.enabled, type: "checkbox", onChange: function (event) { return _this.onChange(event); }, onClick: function (event) { return event.stopPropagation(); }, checked: this.state.value }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && { "data-wcag22": "" }));
            this.fillWithBuiltinProperties(checkboxAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.span, null, React.createElement(HtmlTags_1.HtmlTags.input, tslib_1.__assign({}, checkboxAttributes)), this.createValidationElement());
        };
        Checkbox = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Checkbox);
        return Checkbox;
    }(Widget_1.InputWithVariableWidget));
    exports.Checkbox = Checkbox;
});
//# sourceMappingURL=Checkbox.js.map;
